import { BookingDataContext } from "containers/data_context";
import moment from "moment";
import { useCallback, useContext } from "react";
import { useMedia } from "react-media";
import MEDIA_QUERIES from "constants/media_queries";
import getUrlParams from "utils/get_url_params";

export default function useHandlePromotions(bookedPromos = []) {
  const { params, promotionInfo, channelId } = useContext(BookingDataContext);

  const { source } = getUrlParams();

  const { data: promotionData = [] } = promotionInfo;
  const matchedQueries = useMedia({ queries: MEDIA_QUERIES });

  const isBookableDay = (checkinDate, checkoutDate, bookable_days) => {
    let currentDay = checkinDate.clone(); // Start with check-in date
    const bookableDays = bookable_days || [];

    // Loop through each day from check-in to the day before check-out
    while (currentDay.isBefore(checkoutDate, "day")) {
      const dayName = currentDay.format("dddd").toLowerCase(); // Get day name (e.g., 'monday', 'tuesday')

      if (!bookableDays.includes(dayName)) {
        return false; // If any day is not bookable, return false
      }

      currentDay.add(1, "day"); // Move to the next day
    }

    return true; // All days are bookable
  };

  const getRoomPromotions = useCallback(
    (id) => {
      // don't apply promotions for request redirecting from google
      //
      if (typeof source === "string" && source?.toLowerCase() === "google") {
        return [];
      }
      moment.locale("en");
      let filteredPromotions = [];
      let nonStackPromos = [];
      const checkinDate = moment(params?.checkinDate).locale("en");
      const checkoutDate = moment(params?.checkoutDate).locale("en");
      const dateDifference = checkoutDate.diff(checkinDate, "days");

      if (promotionData?.length) {
        let isAlreadyBookedRoom = bookedPromos?.findIndex((br) => br?.room_id === id);
        if (isAlreadyBookedRoom !== -1) {
          if (bookedPromos[isAlreadyBookedRoom]?.discount_sequences?.length > 0) {
            filteredPromotions = bookedPromos[isAlreadyBookedRoom]?.discount_sequences?.map(
              (ds) => ds?.promotion,
            );
          } else {
            filteredPromotions = [];
          }
        } else {
          promotionData.forEach((promos) => {
            if (promos?.room_types?.find((rt) => rt?.channex_room_type_id === id)) {
              const isMobile = matchedQueries.xs || matchedQueries.sm || matchedQueries.md;
              const isMobilePromo = promos?.target === "mobile" ? isMobile : true;
              let data = JSON.parse(localStorage.getItem("userInfo"));
              data = data?.channelId === channelId ? data : null;
              const isCountryExist = promos?.target_countries?.length
                ? promos?.target_countries?.findIndex(
                    (con) =>
                      con?.alpha_two_code?.toLowerCase() === data?.country_code?.toLowerCase(),
                  )
                : -1;

              const isCountryPromo = promos?.target === "country" ? isCountryExist !== -1 : true;

              if (
                checkinDate.isSameOrAfter(promos?.start_date) &&
                checkoutDate.isSameOrBefore(promos?.end_date) &&
                dateDifference >= promos?.stay_length &&
                isBookableDay(checkinDate, checkoutDate, promos?.bookable_days || []) &&
                isMobilePromo &&
                isCountryPromo
              ) {
                let allPromos = [...nonStackPromos];

                if (allPromos?.length > 0) {
                  allPromos.forEach((promo, index) => {
                    if (promo?.id !== promos?.id) {
                      if (
                        !promo.stacked_promotions?.some((st) => st?.id === promos?.id) &&
                        !promos?.stacked_promotions?.some((st) => st?.id === promo?.id)
                      ) {
                        if (promo?.discount < promos?.discount) {
                          filteredPromotions = filteredPromotions?.filter(
                            (pr) => pr?.id !== promo?.id,
                          );
                          filteredPromotions.push(promos);
                        }
                      } else {
                        let promo1Exists = filteredPromotions?.findIndex(
                          (pr) => pr?.id === promo?.id,
                        );
                        if (promo1Exists === -1) {
                          filteredPromotions.push(promo);
                        }

                        let promo2Exists = filteredPromotions?.findIndex(
                          (pr) => pr?.id === promos?.id,
                        );
                        if (promo2Exists === -1) {
                          filteredPromotions.push(promos);
                        }
                      }
                    }
                  });
                } else {
                  filteredPromotions.push(promos);
                }
                nonStackPromos.push(promos);
              }
            }
          });
        }
      }

      let uniquePromos = Array.from(new Set(filteredPromotions.map((promo) => promo.id))).map(
        (dicsocundId) => filteredPromotions.find((promo) => promo.id === dicsocundId),
      );

      return uniquePromos?.sort((a, b) => b?.discount - a?.discount);
    },
    [promotionData, bookedPromos, params, matchedQueries, source],
  );
  return {
    promotionData,
    getRoomPromotions,
  };
}
